import type { PropsWithChildren } from 'react';
import { cn } from '@dinewise/utils';

type PaymentsContentPanelProps = PropsWithChildren<{
  className?: string;
  overlapHeader?: boolean;
}>;

export const PaymentsContentPanel = ({
  children,
  className,
  overlapHeader = false,
}: PaymentsContentPanelProps) => {
  return (
    <section
      className={cn(
        'flex min-h-0 flex-1 flex-col',
        'bg-gradient-to-b from-ande-surface-100 to-ande-surface-50',
        overlapHeader && '-mt-1 rounded-t-3xl',
        className,
      )}
    >
      {children}
    </section>
  );
};
